import { PersonsListContainer } from "../containers/PersonsListContainer";

export const PersonsListPage = () => (
    <PersonsListContainer/>
)